'use client';

import Reveal from './Reveal';

export default function FounderMessage() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <Reveal>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">作者の思い</h2>
      </Reveal>
      <Reveal className="mt-3">
        <p className="text-gray-800 max-w-3xl">
          税務に関わる人の不安を少しでも軽くしたい。複雑な手続きや条文の前で立ち止まってしまう瞬間に、もう一歩進むための対話を届けたい。そんな願いから、このプロダクトを作りました。
          理屈ではなく、日々の感情に寄り添う体験を――AmiJ2株式会社は、その思いを大切にしています。
        </p>
      </Reveal>
    </section>
  );
}
